import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const CheckCircle = createSvgIcon(
  () => (
    <path d="M48.4375 24.2188C48.4375 10.9375 37.5 0 24.2188 0C10.8398 0 0 10.9375 0 24.2188C0 37.5977 10.8398 48.4375 24.2188 48.4375C37.5 48.4375 48.4375 37.5977 48.4375 24.2188ZM21.3867 37.1094C20.8008 37.6953 19.7266 37.6953 19.1406 37.1094L8.98438 26.9531C8.39844 26.3672 8.39844 25.293 8.98438 24.707L11.2305 22.5586C11.8164 21.875 12.793 21.875 13.3789 22.5586L20.3125 29.3945L34.9609 14.7461C35.5469 14.0625 36.5234 14.0625 37.1094 14.7461L39.3555 16.8945C39.9414 17.4805 39.9414 18.5547 39.3555 19.1406L21.3867 37.1094Z" />
  ),
  '0 0 49 49'
);
